import React from 'react';
import { TranslationKeys } from '../../core/constants/translationKeys';

function TicketTitle({
  t,
  tickets,
  isBetsClosed,
  currencyCode,
  totalTicketAmount,
  totalTicketsWinAmount,
  handleClearAllTickets,
}) {
  return (
    <div className='keno-total-bet-row'>
      <div className='keno-total-bet-number-block'>
        <span className='icon-ticket' />
        <span className='keno-total-bet-number'>{tickets.length}</span>
      </div>
      <div className='keno-total-bet-txt-block'>
        <div className='keno-total-bet-txt'>
          {t(TranslationKeys.TotalBet)} {totalTicketAmount} {currencyCode}
        </div>
        {totalTicketsWinAmount !== null && (
          <div className='keno-total-bet-txt win-txt'>
            {t(TranslationKeys.TotalWin)} {totalTicketsWinAmount} {currencyCode}
          </div>
        )}
      </div>
      {!isBetsClosed && (
        <div className='keno-total-bet-delete' data-title='Delete' onClick={handleClearAllTickets}>
          <span className='icon-delete' />
        </div>
      )}
    </div>
  );
}

export default TicketTitle;
